/**
 * AnimationSequence
 * @class
 */
class AnimationSequence {

  /**
   * @instance
   */
  constructor() {
    this.playLoop = {};
  }

  /**
   * initialize
   * @instance
   * @param initialVals {array} animation initial vals
   *
   * @example initialVals array
   *   [
   *     {
   *       e: '.sapmle',
   *       p: { display: 'none' },
   *     },
   *   ]
   */
  initialize(initialVals) {
    if(!initialVals) return;
    _.forEach(initialVals, (obj) => {
      _.forEach(obj.e, (el) => {
        _.forEach(obj.p, (val, key) => {
          _.forEach(el, (_el) => {
            _el.style[key] = val;
          });
        });
      });
    });
  }

  /**
   * animation sequence
   * @instance
   * @param sequence {array} animation sequence
   * @param opts {object} before and after function
   *
   * @example sequence object
   *   [
   *     {
   *       e: '.sample',
   *       p: { opacity: 1, },
   *       o: { duration: 500, display: 'block', },
   *     }
   *   ]
   */
  runSequence(sequence, opts = {}) {
    const defOpts = {
      begin   : null,
      complete: null,
    };

    const { begin, complete } = _.defaults(opts, defOpts);

    if(!sequence) return;

    const len = sequence.length;
    if(!len){
      if(begin) begin();
      if(complete) complete();
      return;
    }
    Velocity.RunSequence(_.map(sequence, (obj, i) => {
      const _obj = {
        elements  : obj.e,
        properties: obj.p,
        options   : obj.o,
      };
      if(i === 0) {
        _obj.options.begin = begin;
      }
      if((len - 1) === i) {
        _obj.options.complete = complete;
      }
      return _obj;
    }));
  }

  /**
   * loop animation sequence
   * @instance
   * @param sequences {array} animation sequences
   * @param interval {number} sequence interval
   */
  loopSequences(sequences, interval = 0) {
    const timer = [];
    _.forEach(sequences, (sequence, i) => {
      this.playLoop[i] = true;
    });
    const runSequences = (sequences, interval) => {
      _.forEach(sequences, (sequence, i) => {
        if( typeof timer !== 'undefined' && timer !== null ) {
          clearTimeout(timer[i]);
        }
        if(this.playLoop[i]) {
          timer[i] = setTimeout( () => {
            this.runSequence(sequences, {
              complete: () => {
                runSequences(sequences, interval);
              }
            });
          }, interval);
        };
      });
    };
    runSequences(sequences, interval);
  }

}

/**
 * class exports
 */
module.exports = AnimationSequence;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/velocity/animation-sequence.js
 **/